import type { ReactNode } from "react";

export type LegalFaqItem = {
  q: string;
  /** Plain-text answer — this exact string is what ships in FAQPage JSON-LD. */
  a: string;
  /** Optional richer rendering (links). Must say the same thing as `a`. */
  render?: ReactNode;
};

/**
 * Procurement-style FAQ block used on the legal pages. The visible copy and
 * the FAQPage JSON-LD are generated from the same array, so the schema can
 * never claim something a reader does not see on the page.
 */
export function LegalFaq({
  heading,
  intro,
  items,
  id = "faq",
}: {
  heading: string;
  intro?: string;
  items: LegalFaqItem[];
  id?: string;
}) {
  return (
    <section id={id} className="mt-12 border-t border-border pt-10">
      <h2 className="font-serif text-2xl text-ink">{heading}</h2>
      {intro && <p className="mt-3 text-ink/85 leading-relaxed">{intro}</p>}
      <dl className="mt-6 space-y-6">
        {items.map((item) => (
          <div key={item.q}>
            <dt className="font-serif text-lg text-ink">{item.q}</dt>
            <dd className="mt-2 text-ink/85 leading-relaxed">
              {item.render ?? item.a}
            </dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
